<template>

    <div class="content-wrap">
  
      <div class="register-wrap">
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="이름" required>
                <template #end="{id}">
                  <ElInput 
                    ref="userNm"
                    v-bind="{
                      id:'id',
                      modelValue : state.userParams.user_nm
                    }"
                    readonly
                  />
                </template>
  
              </ElLabel>
              
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="사번" required>
                <template #end="{id}">
                  <ElInput 
                    v-model="state.userParams.employee_id"
                    readonly
                  />
                </template>
  
              </ElLabel>
  
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="아이디" required>
                <template #end="{id}">
                  <div class="input-group">
                    <ElInput
                      ref="userIdRef"
                      v-model="state.userParams.user_id"
                      readonly
                    />
                  </div>
                </template>
  
              </ElLabel>
  
  
              <div id="" class="form-text text-primary">
                {{ state.idCheckMsg }}
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="부서" required>
                <template #end="{id}">
                  <div class="flex-fill" @click="openDeptModal">
                    <ElInput 
                      ref="deptModalBtn"
                      :id="id"
                      v-model="state.userParams.dept_nm" 
                      readonly
                    />
                  </div>
                </template>
              </ElLabel>
              
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel  name="휴대폰 번호" required>
                <template #end="{id}">
                  <ElInput 
                    ref="mobile"
                    phoneNumber
                    :modelValue="state.userParams.mobile"
                    :maxlength="13"
                    readonly
                  />
                </template>
              </ElLabel>
              
            </div>
          </div>
          <!-- <div class="col-md-3">
            <div class="mb-3">
              
              <ElLabel  name="비밀번호" required>
                <template #end="{id}">
                  <ElInput 
                    ref="passwordRef"
                    v-model="state.userParams.passwd"
                    type="password"
                  />
                </template>
              </ElLabel>
                
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
                <ElLabel  name="비밀번호 확인" required>
                  <template #end="{id}">
                    <ElInput 
                      v-model="state.chkPasswd"
                      type="password"
                    />
                  </template>
                </ElLabel>
            </div>
          </div> -->
          <!-- <div class="col-md-3" v-if="state.pageType === 'update'">
            <div class="mb-3">
              <ElLabel  name="비밀번호 변경">
                <template #end="{id}">
                  <ElButton class="btn btn-primary btn-search" @buttonClick="openPwdChng">비밀번호 변경</ElButton>
                </template>
              </ElLabel>
                
            </div>
          </div>
          <div class="col-md-3" v-if="state.pageType !== 'update'">
            <div class="mb-3">
              
              <ElLabel  name="비밀번호" required>
                <template #end="{id}">
                  <ElInput 
                    ref="password"
                    type="password"
                    v-bind="{
                      id:id,
                      modelValue : state.userParams.passwd
                    }"
                    @update:modelValue="r=>state.userParams.passwd=r"
                  />
                </template>
              </ElLabel>
                
            </div>
          </div>
          <div class="col-md-3" v-if="state.pageType !== 'update'">
            <div class="mb-3">
                <ElLabel  name="비밀번호 확인" required>
                  <template #end="{id}">
                    <ElInput 
                      ref="rePasswd"
                      type="password"
                      v-bind="{
                        modelValue : state.chkPasswd
                      }"
                      @update:modelValue="r=>state.chkPasswd=r"
                      @focusout="chkPasswdResult()"
                    />
                  </template>
                </ElLabel>
            </div>
          </div> -->
          <div class="col-md-3">
            <div class="mb-3">
                <ElLabel  name="이메일" required>
                  <template #end="{id}">
                    <ElInput 
                      ref="email"
                      type="email"
                      v-bind="{
                        modelValue : state.userParams.email
                      }"
                      @update:modelValue="r=>state.userParams.email=r"
                      readonly
                    />
                  </template>
                </ElLabel>
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-md-3">
            <div class="mb-4">
              <ElLabel name="재/퇴직여부">
                <template #end>
                  <SelectCode chk_ess='Y' :matchCd="state.userParams.retire_yn" cd_gr="RTR_CD" @return="(r) => (state.userParams.retire_yn = r.cd_id)" :is-show="false"/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="사용자 유형">
                <template #end>
                  <div class="d-flex">
                    <div class="flex-fill">
                      <div class="dropdown">
                        <ElSelect v-model="state.userParams.auth_grp_id" :options="state.sUsrTypeList" :disalbed="true"/>
                      </div>
                    </div>
                    <div class="ms-1" @click="openAuthModal">
                      <ElButton type="btn-s-tb">권한보기</ElButton>
                    </div>
  
                    
                  </div>
                </template>
              </ElLabel>
            </div>
            <ElButton ref='menuModalBtnRef' type="btn-s-tb" data-bs-toggle="modal" data-bs-target="#exampleModal" v-show="false"/>
          </div>
  
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="활성화/비활성화">
  
                <template #end="{id}">
                  <div class="radio-btn-toggle d-flex" :id="id">
                    <ElLabel name="활성화" classNm="btn btn-sm flex-fill">
                      <template #start="{id}">
                        <ElRadio
                          :id="id"
                          classNm="btn-check"
                          v-model="state.userParams.enable_yn"
                          value="Y"
                          disabled
                        />
                      </template>
                    </ElLabel>
  
                    <ElLabel name="비활성화" classNm="btn btn-sm flex-fill">
                      <template #start="{id}">
                        <ElRadio
                        :id="id"
                          classNm="btn-check"
                          v-model="state.userParams.enable_yn"
                          value="N"
                          disabled
                        />
                      </template>
                    </ElLabel>
                  </div>
                </template>
              </ElLabel>
  
              
  
  
            </div>
          </div>
        </div>
        <div class="row band">
          <Caption :tb-id="'user'" />
        </div>
      </div><!-- //register-wrap -->
  
      <div class="text-end py-3">
        <ElButton type="primary" @buttonClick="router.back()">이전</ElButton>
      </div>
      <DeptRegModal ref="deptRegModalRef" @return="r => getDept(r)" />
  
  
    </div>
  
  <MenuAuthModal ref="menuAuthModal"/>
  <PwdChangeModal ref="pwdChangeModalRef"/>
  </template>
  
  <script setup>
  
  import { reactive, computed, onBeforeMount, ref } from 'vue'
  
  import { useRouter } from "vue-router";
  import routerCmn from '@/js/vueRouterCmn';
  import DeptRegModal from '@/components/common/modal/DeptRegModal.vue';
  import common from '@/js/common';
  import SelectCode from "@/components/common/SelectCode.vue";
  import Caption from '@/components/common/CaptionList.vue';
  import PwdChangeModal from '@/components/common/modal/PwdChangeModal.vue';
  import MenuAuthModal from '@/components/common/modal/MenuAuthModal.vue'
  import { useCodeStore } from '@/store/code'
  const codeStore = useCodeStore()
  
  import { useLoading } from '@/composable/Loading.js'
  const { setIsLoading } = useLoading()
  import { userSearch, idCheck, getNewEmployeeID, userEdit } from '@/api/userInfo';
  import { getAuthGrpList } from '@/api/userInfo';
  const menuAuthModal = ref()
  const pwdChangeModalRef = ref()
  const userNm = ref();
  const userIdRef = ref();
  const deptModalBtn = ref();
  const mobile = ref();
  const passwordRef = ref();
  const rePasswd = ref();
  const email = ref();
  const router = useRouter();
  const deptRegModalRef = ref()
  const treeTableRef = ref()
  const menuModalBtnRef = ref()
  
  const state = reactive({
    duplicateId : true,
    beforeId : '',
    userParams: {
      user_seq: '',
      user_nm: '',
      employee_id: '',
      user_id: '',
      dept_nm: '',
      dept_cd: '',
      up_dept_cd: '',
      mobile: '',
      passwd: '',
      email: '',
      retire_yn: 'N',
      auth_grp_id: 'U',
      enable_yn: 'Y',
      // caption1 : '',
      // caption2 : '',
      // caption3 : '',
      // caption4 : '',
    },
    pageType: 'insert',
    typeName: '',
    idCheckMsg: '',
    idCheckCode: '',
    chkPasswd: '',
  
    sRetireList: [
      { text: '재직', value: 'Y' },
      { text: '퇴직', value: 'N' },
    ],
  
    sUsrTypeList: []
  
  
  });
  
  
  onBeforeMount(async () => {
    await getAuthGroup()
    let user_seq = history.state.user_seq;
  
    if (user_seq) {
      state.pageType = 'update'
  
      let param = {
        user_seq: user_seq
      }
      try {
        setIsLoading(true)
        const res = await userSearch(param)
        let detailCf = res.rtn[0]
        state.userParams.user_seq = detailCf.user_seq
        state.userParams.user_nm = detailCf.user_nm
        state.userParams.employee_id = detailCf.employee_id
        state.userParams.user_id = detailCf.user_id
  
        state.beforeId = detailCf.user_id
        state.duplicateId = false
        state.userParams.dept_nm = detailCf.dept_nm
        state.userParams.dept_cd = detailCf.dept_cd
        state.userParams.up_dept_cd = detailCf.up_dept_cd
        state.userParams.mobile = detailCf.mobile
        // state.userParams.passwd = detailCf.passwd
        // state.chkPasswd = detailCf.passwd
        state.userParams.email = detailCf.email
        state.userParams.retire_yn = detailCf.retire_yn
        state.userParams.auth_grp_id = detailCf.auth_grp_id
        state.userParams.enable_yn = detailCf.enable_yn
  
        state.retireModel = detailCf.retire_yn
        state.usrTypeModel = detailCf.auth_grp_id
      } catch (err) {
        console.log('사용자 입력/수정 api 에러', err)
        alert('사용자 입력/수정에 실패했습니다.')
        routerCmn.routerPush('/cf/MCF_US_002')
      } finally {
        setIsLoading(false)
      }
    }else{
      fetchNewEmployeeID()
    }
  })
  
  
  const getTypeName = computed(() => {
    if (state.pageType == 'insert') {
      state.typeName = '등록'
    } else {
      state.typeName = '수정'
    }
    return state.typeName;
  });
  
  
  //이메일 형식
  const chkEmailMark = (data) => {
    if(!common.checkEmail(data)){
      alert("이메일 형식을 확인해주세요")
      return false
    }else{
      state.userParams.email
    }
  };
  
  // 이름 특수문자 체크
  const chkNameMark = (val) => {
    if (val != undefined && val != '' && common.checkSpecChar2(val)) {
      alert('특수문자는 입력할 수 없습니다.')
      state.userParams.user_nm = ''
      userNm.value.focus()
    }
  };
  
  
  
  //아이디 조회(아이디 중복확인)
  const getUserIdCheck = async () => {
  
    let params = {
      user_id: state.userParams.user_id
    }
  
  
    if (params.user_id.length > 0) {
      try {
        setIsLoading(true)
        const res = await idCheck(params)
        if (res.rtn.code_id === '00002') {
          alert('중복된 아이디입니다.')
          state.duplicateId = true
        } else { //TODO
          state.duplicateId = false
          state.idCheckMsg = '사용 가능한 아이디 입니다.';
        }
        return state.idCheckMsg;
      } catch (err) {
        console.log('/userInfo/userSelect ERROR!! => ' + err)
        alert('api 에러 발생!!')
      } finally {
        setIsLoading(false)
      }
    } else {
      alert('사용자 아이디를 입력해 주세요.')
    }
  };
  
  // 아이디가 입력되지 않으면 아이디 중복관련 메시지를 Clear 한다.
  const idMsgClear = () => {
    state.idCheckMsg = ''
  
    if(state.pageType === 'update' && state.beforeId === state.userParams.user_id){
       state.duplicateId = false
       return
    }
    
    state.duplicateId = true
  };
  
  const getDept = (value) => {
    state.userParams.dept_cd = value.dept_cd
    state.userParams.up_dept_cd = value.up_dept_cd
    state.userParams.dept_nm = value.dept_nm
  };
  
  //신규생성 사번 가져오기
  const fetchNewEmployeeID = async () => {
    if (state.pageType == 'insert') {
      try {
        setIsLoading(true)
        const res = await getNewEmployeeID()
        state.userParams.employee_id = res.rtn.new_employee_id
      } catch (err) {
        console.log('/userInfo/getNewEmployeeID ERROR!! => ' + err)
        alert('api 에러 발생!!')
      } finally {
        setIsLoading(false)
      }
    }
  };
  
  const getMobileMask = (data) => {
    state.userParams.mobile = common.phoneFormat(data)
  };
  
  //비밀번호 확인
  const chkPasswdResult = () => {
  
    if (state.chkPasswd != state.userParams.passwd && state.chkPasswd.trim() != '') {
      alert('비밀번호가 맞지 않습니다. 다시 확인 후 입력해 주세요');
      return false;
    }
  };
  
  // 필수 입력값 확인
  const checkValidation = () => {
  
    //6가지 항목  성향 -> default 값 존재
    let msg = codeStore.getCodeMsg('77777'); // 해당 항목은 필수 입력값입니다.
  
    if (!state.userParams.user_nm.trim()) { //이름
      alert(msg);
      userNm.value.input.focus();
      return false;
    }
  
    if (!state.userParams.user_id.trim()) {  //아이디
      alert(msg);
      userIdRef.value.input.focus();
      return false;
    }
  
    if (state.duplicateId) {  //아이디
      alert('중복확인을 진행해주세요.');
      userIdRef.value.input.focus();
      return false;
    }
  
    if (!state.userParams.dept_nm.trim()) {  //부서
      alert(msg);
      deptModalBtn.value.input.focus();
      return false;
    }
  
    if (!state.userParams.mobile.trim()) {  //휴대폰번호
      alert(msg);
      mobile.value.input.focus();
      return false;
    }
  
    if (state.userParams.mobile.length < 13 ) {  //휴대폰번호 자릿수 체크 
      alert('휴대전화 번호를 확인하세요')
      mobile.value.input.focus();
      return false;
    }
  
    if (!state.userParams.passwd.trim()){
      alert(msg);
      passwordRef.value.input.focus();
      return false;
    }
  
    if (state.userParams.passwd.trim()) {  //비밀번호
      
      if (!common.checkPwdForm(state.userParams.passwd)) {  //비밀번호
        alert('비밀번호 규칙에 맞지 않습니다.(영대/소문자, 숫자, 특수문자 포함 8자리 이상이여야합니다.)');
        passwordRef.value.input.focus();
        return false;
      }
  
  
      if (state.chkPasswd == undefined || state.chkPasswd.trim() == '') {  //비밀번호 확인
        alert(msg);
        rePasswd.value.input.focus();
        return false;
      }
  
      if (state.chkPasswd.trim() !== state.userParams.passwd.trim()) {  //비밀번호 확인
        alert('비밀번호와 비밀번호 확인 값이 다릅니다.');
        return false;
      }
    }
  
    if (!state.userParams.email.trim()) {  //이메일
      alert(msg);
      email.value.input.focus();
      return false;
    }
  
    if(chkEmailMark(state.userParams.email.trim()) == false){
      email.value.input.focus();
      return false;
    }
  
    RegClick();
  
  };
  
  //사용자 등록/수정
  const RegClick = async () => {
  
    let msg = '정말 ' + state.typeName + '하시겠습니까?';
  
    let sendParams = {
      user_seq: state.userParams.user_seq,
      user_nm: state.userParams.user_nm,
      employee_id: state.userParams.employee_id,
      user_id: state.userParams.user_id,
      dept_nm: state.userParams.dept_nm,
      dept_cd: state.userParams.dept_cd,
      up_dept_cd: state.userParams.up_dept_cd,
      mobile: state.userParams.mobile,
      passwd: state.userParams.passwd,
      email: state.userParams.email,
      retire_yn: state.userParams.retire_yn,
      auth_grp_id: state.userParams.auth_grp_id,
      enable_yn: state.userParams.enable_yn,
      attachFileVO: {
        file_seq: "",
        del_file_seq: "",
        file_div_id: "10",
      },
    };
  
  
    // 등록, 수정 처리
    if (confirm(msg)) {
      try {
        setIsLoading(true)
        const res = await userEdit(sendParams)
        alert(state.typeName + ' 성공했습니다. 조회 페이지로 이동합니다.')
        router.push({ name: 'MCF_US_001' })
      } catch (err) {
        alert("전송 중 에러가 발생하였습니다.")
      } finally {
        setIsLoading(false)
      }
    }
  
  }
  
  
  function openDeptModal() {
    deptRegModalRef.value.openModal()
  }
  
  async function getAuthGroup(){
    try{
      setIsLoading(true)
      const res = await getAuthGrpList()
      if(res.rtn){
        res.rtn.forEach((item)=>{
          state.sUsrTypeList.push({text : item.auth_grp_nm , value : item.auth_grp_id})
        })
      }
    }catch(e){
      console.log(e)
    }finally{
      setIsLoading(false)
    }
    
  }
  
  function openAuthModal(){
    if(!state.userParams.auth_grp_id){
        alert('설정된 권한이 없습니다.')
        return
    }
    menuAuthModal.value.openModal(state.userParams.auth_grp_id)
  }
  
  
  </script>